import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoaderService } from './../../services/loader.service';
import { Component, OnInit, HostListener } from '@angular/core';
import { FragmentService } from '../../services/fragment.service';
import { environment } from 'environments/environment';
import { FirstPageLoadService } from 'app/services/firstSiteLoad.service';
import { MetaService } from 'app/services/meta.service';
import { Globals } from 'app/globals';
import { BreakpointService } from 'app/modules/breakpoint/breakpoint.service';
import { Renderer2 } from '@angular/core';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
  standalone: false,
})
export class ShellComponent implements OnInit {
  subscription: Subscription;
  loadingContent = environment.envName === 'development' ? false : true;
  showGlobalFooter = true;
  showFooter = true;
  globalFooterOffset = false;
  isSmallFooter = false;
  footerFor;
  sidebarMetadata: any;
  isMobileView = false;
  constructor(
    public fragmentService: FragmentService,
    public loaderService: LoaderService,
    private firstPageLoadService: FirstPageLoadService,
    private router: Router,
    private metaService: MetaService,
    public globals: Globals,
    private breakpointService: BreakpointService,
    private renderer: Renderer2
  ) {}
  ngOnInit() {
    this.loaderService.loadingContent.subscribe((loading: boolean) => {
      this.showFooter = !loading;
    });
    this.breakpointService.getBreakpointObservable().subscribe((breakpoint) => {
      this.isMobileView = breakpoint === 'xs';

      if (this.isMobileView) {
        this.renderer.addClass(document.body, 'theme-mobile');
      } else {
        this.renderer.removeClass(document.body, 'theme-mobile');
      }
    });
    // Universal handler for loader. This handles the loader for all markdown content based pages
    // this.router.events.subscribe((event: any) => {
    //   if (event instanceof NavigationEnd) {
    //     this.loadingContent = this.firstPageLoadService.loadContent(window.location.pathname);
    //   }
    // });
    // Show header and footer by default
    // this.headerFooterService.showHeaderFooter.next(true);
    // this.headerFooterService.showHeaderFooter.subscribe((bool) => {
    //   this.showHeaderFooter = bool;
    // });
    /**
     * Added logic to show footer in content container width,
     * as per convergence api overview page
     */
    this.metaService.metadata.subscribe((meta) => {
      if (meta && (meta.title || meta.template)) {
        this.sidebarMetadata = meta;
      }
      const isSupportPage = meta && meta.title && meta.title.toLowerCase() === 'support';

      if (
        !meta?.template ||
        (meta.template === 'public' && !isSupportPage) ||
        meta.template === 'contact-page' ||
        meta.template === 'api-overview' ||
        meta.template === 'all-product' ||
        meta.template === 'app-product-landing' ||
        meta.template === 'product-landing' ||
        meta.template === 'category' ||
        meta.template === 'doc-page' ||
        meta.template === 'app-api-doc' ||
        meta.template === 'prod-doc-page' ||
        meta.template === 'article' ||
        meta.template === 'redoc' ||
        meta.template === 'sdk' ||
        meta.template === 'contact-sales'
      ) {
        this.showGlobalFooter = false;
      } else {
        this.showGlobalFooter = true;
      }

      this.globalFooterOffset = meta && meta.template && meta.template === 'sdk';

      this.isSmallFooter =
        meta.type === 'Platforms' || meta.type === 'Enterprise' || meta.type === 'Smb' || meta.type === 'Payfac';
      this.footerFor =
        meta.type === 'Platforms'
          ? 'platforms'
          : meta.type === 'Enterprise'
          ? 'enterprise'
          : meta.type === 'Smb'
          ? 'smb'
          : meta.type === 'Payfac'
          ? 'payfac'
          : meta.type === 'Financial Institution'
          ? 'financial-institution'
          : meta.type === 'Independent Sales Org'
          ? 'independent-sales-organization'
          : meta.type === 'Independent Software Vendor'
          ? 'independent-software-vendor'
          : meta.type === 'Independent Software Vendor'
          ? 'independent-software-vendor'
          : meta.type === 'customerexperience'
          ? 'customer-experience'
          : meta.type === 'home'
          ? 'home'
          : '';
    });
  }
}
